import SamsungOrderInvoiceService from 'src/services/samsungOrderInvoices';
import {
  IFiltersSamsungOrderInvoice,
  IPaginationSamsungOrderInvoice
} from 'src/services/samsungOrderInvoices/samsungOrderInvoicesService';
import SamsungOrderInvoiceModel from 'src/model/samsungOrderInvoice.model';
import types from './types';
import { IInitialState } from 'src/store/initialState';
import { downloadFile } from 'src/utils/downloadHelper';

const searchSamsungOrderInvoices = (
  samsungRequest: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'],
  pagination: IPaginationSamsungOrderInvoice = { page: 0, size: 20 }
) => (dispatch: any) => {
  const checkFilters: any = {
    productCode: samsungRequest.productCode,
    customerCode: samsungRequest.customerCode,
    orderReference: samsungRequest.orderReference,
    orderNumber: samsungRequest.orderNumber,
    palletRegNumber: samsungRequest.palletRegNumber,
    ticket: samsungRequest.ticket,
    dateFrom: samsungRequest.dateFrom
      ? samsungRequest.dateFrom.format('yyyy-MM-DD')
      : null,
    dateTo: samsungRequest.dateTo
      ? samsungRequest.dateTo.format('yyyy-MM-DD')
      : null
  };
  // dateRange: request.orderFromDate ? request.orderFromDate : null
  //        sort: filters.sort ? filters.sort : null,
  //        status: filters.status ? filters.status : 'open'
  SamsungOrderInvoiceService.getOrdersAndInvoices(checkFilters, pagination)
    .then((response: any) => {
      dispatch(portalData(response.dataList));
      dispatch(samsungResultData(response.dataList));
      dispatch(samsungResultPageInformation(response.data));
    })
    .catch((error: any) => {
      console.log(error);
    });
};

const exportSamsungOrdersInvoices = (samsungRequest: any) => (
  dispatch: any
) => {
  const checkFilters: any = {
    productCode: samsungRequest.productCode,
    customerCode: samsungRequest.customerCode,
    orderReference: samsungRequest.orderReference,
    orderNumber: samsungRequest.orderNumber,
    palletRegNumber: samsungRequest.palletRegNumber,
    ticket: samsungRequest.ticket,
    dateFrom: samsungRequest.dateFrom
      ? samsungRequest.dateFrom.format('yyyy-MM-DD')
      : null,
    dateTo: samsungRequest.dateTo
      ? samsungRequest.dateTo.format('yyyy-MM-DD')
      : null
  };
  if (samsungRequest.userName === 'PTMANAGER') {
    checkFilters['unlimited'] = 'true';
  }
  SamsungOrderInvoiceService.exportOrdersAndInvoices(checkFilters)
    .then((response: any) => {
      console.log(response.data);
      downloadFile(response.data, `Samsung_Order_Invoice.csv`, 'text/csv');
    })
    .catch((error: any) => {
      console.log(error);
    });
};

const portalData = (data: SamsungOrderInvoiceModel[]) => {
  return { type: types.PORTAL_DATA, payload: data };
};

const samsungResultData = (data: any[]) => {
  const transformedResultData = SamsungOrderInvoiceService.transformSamsungResult(
    data
  );
  return { type: types.RESULT_DATA, payload: transformedResultData };
};

const samsungResultPageInformation = (response: any) => {
  const pageInfo = SamsungOrderInvoiceService.getPageInformation(response);
  return { type: types.SET_PAGE_INFO, payload: pageInfo };
};

const updateSamsungSearchForm = (samsungSearchForm: any) => {
  return { type: types.SET_SAMSUNG_SEARCH_FORM, payload: samsungSearchForm };
};

export default {
  searchSamsungOrderInvoices,
  exportSamsungOrdersInvoices,
  updateSamsungSearchForm
};
